var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-capitalize button-shadow white--text mr-1",attrs:{"elevation":"1","color":"secondary","loading":_vm.isLoading},on:{"click":_vm.sendToCheckout}},[_vm._v("Get Memebership")])}
var staticRenderFns = []

export { render, staticRenderFns }